export function getMask(mask, maskInside) {
  return {
    enable: mask,
    mask: 0xff,
    func: {
      cmp: 514,
      ref: maskInside ? 1 : 0,
      mask: 0xff
    }
  };
}
//# sourceMappingURL=stencli.js.map